import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d3ad260"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "inner" }

import { withDefaults, computed } from 'vue'

interface Props {
  type?: 'inner' | 'over'
  message?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppLoading',
  props: {
    type: { default: 'inner' },
    message: { default: '読みこみ中' }
  },
  setup(__props: any) {

const props = __props as { type: 'inner' | 'over', message: string }

/**
 * AppLoading
 *
 * ローディング
 */



const className = computed(() => {
  return ['appLoading', `appLoading--${props.type}`]
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(_unref(className))
  }, [
    _createElementVNode("span", _hoisted_1, _toDisplayString(__props.message), 1)
  ], 2))
}
}

})